<template>
 <AppDialog :is-open="isOpen"
            size="xxl"
            :ok-text="$t('common.download')"
            :cancel-text="$t('common.close')"
            :ok-disabled="!(logsData && logsData.length > 0)"
            data-locator="documents-logs-dialog"
            @cancel="onCancel"
            @ok="onOk"
 >
   <template v-if="document" #title>{{ $t('project.documents.dialogs.DocumentsLogsDialog.logActivity', { filename: document.basename }) }}</template>
   <template #body>
     <v-data-table :items="logsData"
                   item-key="id"
                   :headers="headers"
                   :loading="loading"
                   :footer-props="{
                     'items-per-page-options': [10, 50, 100],
                   }"
     ></v-data-table>
     <AppDownloadFile v-if="downloadLink" :link="downloadLink">
       <template #default="{submitForm}">
         <div ref="downloadForm"
              class="d-none"
              @click="submitForm"
         ></div>
       </template>
     </AppDownloadFile>
   </template>
 </AppDialog>
</template>

<script>
import AppDownloadFile from '@/common/AppDownloadFile.vue'
import AppDialog from '@/common/dialogs/AppDialog.vue'
import { useLogsStore } from '@/stores/logsStore'

export default {
  name: 'DocumentsLogsDialog',
  components: { AppDialog, AppDownloadFile },
  props: {
    mnemo: {
      type: String,
      required: true,
    },
  },
  setup: () => {
    const logsStore = useLogsStore()
    return { logsStore }
  },
  data () {
    return {
      logs: null,
      headers: [
        {
          title: this.$t('project.documents.dialogs.DocumentsLogsDialog.headers.date'),
          value: 'dateUTC',
        },
        {
          title: this.$t('project.documents.dialogs.DocumentsLogsDialog.headers.user'),
          value: 'userFullname',
        },
        {
          title: this.$t('project.documents.dialogs.DocumentsLogsDialog.headers.action'),
          value: 'type',
        },
        {
          title: this.$t('project.documents.dialogs.DocumentsLogsDialog.headers.description'),
          value: 'description',
        },
      ],
    }
  },
  computed: {
    isOpen () {
      return this.logsStore.logsDialog.isOpen
    },
    document () {
      return this.logsStore.logsDialog.document
    },
    loading () {
      return this.logsStore.fileLogsPending || this.logsStore.folderLogsPending
    },
    logsData () {
      return this.logs?.data || []
    },
    downloadLink () {
      if (this.document?.type === 'file') {
        return `${import.meta.env.VUE_APP_API_URL}/room/${this.mnemo}/downloads/file/${this.document.id}/logs`
      } else if (this.document?.type === 'folder') {
        return `${import.meta.env.VUE_APP_API_URL}/room/${this.mnemo}/downloads/folder/${this.document.id}/logs`
      }
      return null
    },
  },
  watch: {
    isOpen (value) {
      if (value) {
        this.prepareGetLogs()
      }
    },
  },
  methods: {
    onCancel () {
      this.logs = null
      this.logsStore.closeLogsDialog()
    },
    onOk () {
      this.$refs.downloadForm.click()
    },
    prepareGetLogs () {
      if (this.document) {
        if (this.document.type === 'file') {
          this.prepareGetFileLogs()
        } else if (this.document.type === 'folder') {
          this.prepareGetFolderLogs()
        }
      }
    },
    async prepareGetFileLogs () {
      try {
        const response = await this.logsStore.getFileLogs({
          mnemo: this.mnemo,
          fileId: this.document.id,
        })
        this.logs = response.data
      } catch (error) {
        console.error(error.response)
      }
    },
    async prepareGetFolderLogs () {
      try {
        const response = await this.logsStore.getFolderLogs({
          mnemo: this.mnemo,
          folderId: this.document.id,
        })
        this.logs = response.data
      } catch (error) {
        console.error(error.response)
      }
    },
  },
}
</script>
